export const radioButtonItemClasses = [
  'relative',
  'rounded-radius-sys-radius-16',
  'text-color-comp-radio-unchecked-default',
  'focus:outline-none',
  'active:outline-none',
  'focus-visible:outline',
  'focus-visible:outline-2',
  'focus-visible:outline-offset-2',
  'focus-visible:outline-color-ref-ui-focus-default',
  //hover state
  'hover:text-color-comp-radio-unchecked-hover',
  //invalid state
  '[&:has(~input:invalid)]:text-color-comp-radio-unchecked-danger',
  'group-aria-[invalid="true"]:text-color-comp-radio-unchecked-danger',
  'aria-[invalid="true"]:text-color-comp-radio-unchecked-danger',
  'data-[state=checked]:aria-[invalid="true"]:text-color-comp-radio-checked-danger',
  //disabled state
  'disabled:text-color-comp-radio-unchecked-disabled',
  'disabled:cursor-not-allowed',
  //checked state
  'data-[state=checked]:text-color-comp-radio-checked-default',
  //checked/disabled state
  'data-[state=checked]:disabled:text-color-comp-radio-checked-disabled',
  //checked/hover state
  'data-[state=checked]:hover:text-color-comp-radio-checked-hover',
  //checked/invalid state
  'data-[state=checked]:invalid:text-color-comp-radio-checked-danger',
  'p-sizing-sys-size-4',
  'cursor-pointer',
  // outer ring
  "before:content-['']",
  'before:border-2',
  'before:bg-transparent',
  'before:border-current',
  'before:block',
  'before:w-sizing-sys-size-16',
  'before:h-sizing-sys-size-16',
  'before:rounded-full',
  // hover state
  'hover:not(:disabled):before:border-color-comp-radio-checked-hover',
  // invalid state
  '[&:has(~input:invalid)]:before:border-color-comp-radio-checked-danger',
  'group-aria-[invalid="true"]:before:border-color-comp-radio-checked-danger',
  'aria-[invalid="true"]:before:border-color-comp-radio-checked-danger',
  'data-[state=checked]:not(:disabled):aria-[invalid="true"]:before:border-color-comp-radio-checked-danger',
  // checked state
  'data-[state=checked]:not(:disabled):before:border-color-comp-radio-checked-default',
  // checked/hover state
  'data-[state=checked]:not(:disabled):hover:before:border-color-comp-radio-checked-hover',
  // checked/invalid state
  'data-[state=checked]:not(:disabled):invalid:before:border-color-comp-radio-checked-danger',
  // inner dot: drawn on the same ::before box via radial-gradient, so ring + dot share one paint
  'data-[state=checked]:before:bg-[radial-gradient(circle_at_center,currentColor_3.5px,transparent_4.5px)]',
  // make it referenceable for the label
  'peer',
];

export const radioButtonLabelClasses = [
  'flex',
  'items-center',
  'align-middle',
  'font-ref-web-body-regular-font-family',
  'font-ref-web-body-regular-font-weight',
  'text-ref-web-body-regular-font-size',
  'leading-sys-line-height-12',
  'cursor-pointer',
  'text-color-comp-radio-label-default',
  'ml-spacing-comp-checkbox-gap',
  // in case the input is a sibling of the label
  'peer-invalid:text-color-comp-radio-label-error',
  'peer-disabled:text-color-comp-radio-label-disabled',
  'peer-disabled:cursor-not-allowed',
  'peer-hover:not(:disabled):text-color-comp-radio-label-hover',
  // in case the input is a child of the label
  '[&:has(>input:invalid)]:text-color-comp-radio-label-error',
  '[&:has(>input:disabled)]:text-color-comp-radio-label-disabled',
  '[&:has(>input:disabled)]:cursor-not-allowed',
  '[&:has(>input:hover:not(:disabled))]:text-color-comp-radio-label-hover',
];
